import { SET_COUNTRIES, SET_STATES } from './actions'

export const reducer = (state, action) => {
  switch (action.type) {
    case SET_COUNTRIES:
      return { ...state, countries: action.payload }
    case SET_STATES:
      return { ...state, states: action.payload }
    default:
      return state
  }
}
